import { API_GATEWAY_URL } from '../constants/config';
import { withStandardHandlers } from './utils';
export const PRICES_API_URL = `${API_GATEWAY_URL}/prices`;
export const ACTIVATE_BASE_FEATURE_API_URL = `${API_GATEWAY_URL}/base-feature-activation-records`;
export const ACTIVATE_ADDITIONAL_FEATURE_API_URL = `${API_GATEWAY_URL}/additional-feature-activation-records`;
export const PATCH_AUTO_BASE_FEATURE_RENEWAL_API_URL = `${API_GATEWAY_URL}/automatic-base-feature-renewal`;
/**
 * Get prices
 * @param accessToken
 * @return {Prices}
 * */
export const getPrices = (accessToken) => {
    const fn = () => fetch(`${PRICES_API_URL}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    return withStandardHandlers(fn, 'errors.subscription.fetch')();
};
/**
 * Activate base feature
 * @param accessToken
 * @return {boolean}
 * */
export const activateBaseFeature = (accessToken) => {
    const fn = () => fetch(`${ACTIVATE_BASE_FEATURE_API_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({}),
    });
    return withStandardHandlers(fn, 'errors.subscription.activateBaseFeature')();
};
/**
 * Activate additional feature
 * @param accessToken
 * @return {boolean}
 * */
export const activateAdditionalFeature = (accessToken, product) => {
    const fn = () => fetch(`${ACTIVATE_ADDITIONAL_FEATURE_API_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ product }),
    });
    return withStandardHandlers(fn, 'errors.subscription.activateAdditionalFeature')();
};
/**
 * Patch auto base feature renewal
 * @param accessToken
 * @return {boolean}
 * */
export const patchAutoBaseFeatureRenewal = (accessToken, auto_base_feature_renewal) => {
    const fn = () => fetch(`${PATCH_AUTO_BASE_FEATURE_RENEWAL_API_URL}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ auto_base_feature_renewal }),
    });
    return withStandardHandlers(fn, 'errors.subscription.patchAutoBaseFeatureRenewal')();
};
